// extracted by mini-css-extract-plugin
module.exports = {"card":"base-card_card__aKXnW","cardBoxShadow":"base-card_cardBoxShadow__3vX7g","cardBorder":"base-card_cardBorder__jfHmb"};